import { render, staticRenderFns } from "./ResetPwd.vue?vue&type=template&id=7f4b50b4&scoped=true"
import script from "./ResetPwd.vue?vue&type=script&lang=ts"
export * from "./ResetPwd.vue?vue&type=script&lang=ts"
import style0 from "./ResetPwd.vue?vue&type=style&index=0&id=7f4b50b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4b50b4",
  null
  
)

export default component.exports